import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import ColorTable from '../../components/ColorTable/ColorTable';
import { getColorRequestAction } from '../../store/color/colorActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';

const Color = ({ colorList, colorData, getColorRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getColorRequest({});
  }, [getColorRequest]);

  const handleCreateColor = () => {
    navigate('/color/create');
  };

  return (
    <div className="color-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('colors')}</div>
        <ColorTable colorList={colorList} colorData={colorData} />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateColor}
        title={t('createColor')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  colorData: state.colorReducer.colorData,
  colorList: state.colorReducer.colorList,
});

const mapDispatchToProps = (dispatch) => ({
  getColorRequest: (payload) => dispatch(getColorRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Color);
